<template>
  <nav
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" :textWhite="textWhite" />
      <div class="flex-grow-1 text-center px-6 text-bold col-6">
        <span>{{ $t("global.appTitle") }}</span> - {{ $t("seasons.title") }}:
        {{ this.$store.state.season }}
      </div>
      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >
        <div
          class="pe-md-3 d-flex align-items-center"
          :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
          <languages :textWhite="textWhite" />
        </div>
        <div class="text-end">
          <soft-button color="dark" variant="gradient" @click="logout">
            {{ $t("global.logout") }}
          </soft-button>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions } from "vuex";
import Languages from "./Languages.vue";
import axios from "axios";
import SoftButton from "@/components/SoftButton.vue";

export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    async logout() {
      try {
        await axios.post("logout");
        localStorage.removeItem("token");
        localStorage.removeItem("userRole");
        this.$router.push("/");
      } catch (err) {
        console.log(err);
      }
    },
  },
  components: {
    Breadcrumbs,
    Languages,
    SoftButton,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  updated() {
    const navbar = document.getElementById("navbarBlur");

    if (navbar) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 10 && this.$store.state.isNavFixed) {
          navbar.classList.add("blur");
          navbar.classList.add("position-sticky");
          navbar.classList.add("shadow-blur");
        } else {
          navbar.classList.remove("blur");
          navbar.classList.remove("position-sticky");
          navbar.classList.remove("shadow-blur");
        }
      });
    }
  },
};
</script>
